import { logWrapper } from '../../utils';

export default {
  sendFilesController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    '$rootScope',
    'uploader',
    'revisionCheckin',
    'systemConfigService',
    'treeService',
    'uploadRevisionService',
    '$uibModal',
    'validationService',
    'flowService',
    'PermPermissionStore',
    'authService',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $scope,
      $filter,
      $rootScope,
      uploader,
      revisionCheckin,
      systemConfigService,
      treeService,
      uploadRevision,
      uibModal,
      validationService,
      flowService,
      PermPermissionStore,
      authService,
      ETreeItemTypes
    ) {
      'use strict';

      function checkShort(list) {
        return new Set(list).size <= 1;
      }

      function containsUndefinedOrNull(arr) {
        return arr.some((element) => element === undefined || element === null);
      }

      function loadDocumentTypes() {
        var folder = $scope.folder();

        if (folder !== null) {
          $scope.documentTypes = [
            {
              Name: 'LOADING',
            },
          ];

          var id = folder.Id;

          treeService.getFolderDocumentTypes(id).then(
            function (data) {
              $scope.documentTypes = data;
            },
            function () {
              $scope.documentTypes = [
                {
                  Name: 'ERROR',
                },
              ];
            }
          );

          if ($scope.revisionCheckin) {
            //quando for checkin tenho que carregar os campos adicionais
            var selected = $scope.selectedItems();

            treeService
              .getDocumentTypeAdditionalFields(
                $scope.revisionCheckin.documentType.Id
              )
              .then(
                function (data) {
                  //faço as iterações nos docs selecionados e nos campos adicionais setando as listas e se é obrigatorio
                  selected.forEach(function (i) {
                    if (
                      i.revision.RevisionAdditionalFields === undefined ||
                      i.revision.RevisionAdditionalFields === null
                    ) {
                      i.revision.RevisionAdditionalFields = [];
                    }
                    data.forEach(function (addField) {
                      if (
                        addField.items !== null &&
                        addField.items.length > 1
                      ) {
                        addField.items.sort();
                      }

                      var addF = jQuery.grep(
                        i.revision.RevisionAdditionalFields,
                        function (e) {
                          return e.id === addField.id;
                        }
                      )[0];
                      if (addF === undefined || addF === null) {
                        i.revision.RevisionAdditionalFields.push(addField);
                      } else {
                        addF.required = addField.required;
                        if (addField.idList) {
                          addF.idList = addField.idList;
                          addF.items = addField.items;
                        }
                      }
                    });
                  });
                },
                function () {}
              );
          }
        } else {
          $scope.documentTypes = [];
        }
      }

      function fileFilter(item) {
        return !item.revision.uploading;
      }

      function totalFiles() {
        var files = uploader.queue.filter($scope.fileFilter);
        return files.length;
      }

      function selectedItems() {
        return $scope.uploader.queue
          .filter($scope.fileFilter)
          .filter(function (c) {
            if (c.revision._workflow !== null && c.selected) {
              $scope.workflowSelected = c.revision._workflow;
            }
            return c.selected === true;
          });
      }

      function selecteds() {
        return $scope.selectedItems().length;
      }

      function descriptionRequired() {
        return (
          $scope.selectedItems().length === 1 &&
          $scope.isDescriptionRevisionRequired &&
          !$scope.selectedItems()[0].revision.Description
        );
      }

      function title(value) {
        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          itens.forEach(function (i) {
            i.revision.Title = value;
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];

            if (
              itens.every(function (i) {
                return i.revision.Title === first.revision.Title;
              })
            ) {
              return first.revision.Title;
            }
          }
          return '';
        }
      }

      function signDocument(value) {
        $scope.isSignInActions = true;

        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          itens.forEach(function (i) {
            if (value) i.signDocumentD4s = false;
            i.signDocument = value;
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];
            if (
              itens.every(function (i) {
                return i.signDocument === first.signDocument;
              })
            ) {
              return first.signDocument;
            }
          }
          return null;
        }
      }

      function canCheckD4SignSign() {
        if (!authService.user.D4SignTokenApi) return false;
        return true;
      }

      function signDocumentD4s(value) {
        $scope.isSignInActions = false;

        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          itens.forEach(function (i) {
            if (value) i.signDocument = false;
            i.signDocumentD4s = value;
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];
            if (
              itens.every(function (i) {
                return i.signDocumentD4s === first.signDocumentD4s;
              })
            ) {
              return first.signDocumentD4s;
            }
          }
          return null;
        }
      }

      function description(value) {
        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          itens.forEach(function (i) {
            i.revision.Description = value;
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];

            if (
              itens.every(function (i) {
                return i.revision.Description === first.revision.Description;
              })
            ) {
              return first.revision.Description;
            }
          }
          return '';
        }
      }

      function keywords(value) {
        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          itens.forEach(function (i) {
            i.revision.Keywords = value;
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];

            if (
              itens.every(function (i) {
                return angular.equals(
                  i.revision.Keywords,
                  first.revision.Keywords
                );
              })
            ) {
              return first.revision.Keywords;
            }
          }
          return null;
        }
      }

      function folder(value) {
        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          var wf = $scope.workflow();
          var folder = $scope.folder();
          // se o fluxo selecionado para o documento estiver associado na pasta vai resetar
          if (
            folder &&
            wf &&
            folder.Id !== value.Id &&
            wf.IdFolder === folder.Id
          ) {
            //reseta o workflow selecionado
            $scope.workflow(null);
          }
          itens.forEach(function (i) {
            i.revision.folder(value);
          });
          $scope.loadDocumentTypes();
        } else {
          if (itens.length > 0) {
            var first = itens[0];
            if (
              itens.every(
                (i) => i.revision.IdFolder === first.revision.IdFolder
              )
            ) {
              return first.revision.folder();
            }
          }
          return null;
        }
      }

      function documentType(value) {
        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          var changed =
            itens.filter(function (i) {
              return (
                i.revision.IdDocumentType === null ||
                i.revision.IdDocumentType !== value.Id
              );
            }).length > 0;

          itens.forEach(function (i) {
            i.revision.documentType(value);
          });

          if (changed) {
            //reseta o workflow selecionado
            $scope.workflow(null);

            treeService.getDocumentTypeAdditionalFields(value.Id).then(
              function (data) {
                itens.forEach(function (i) {
                  i.revision.NotificationDays = undefined;
                  i.revision.NextRevisionDate = undefined;

                  i.revision.RevisionAdditionalFields = [];
                  data.forEach(function (a) {
                    if (a.items !== null && a.items.length > 1) {
                      a.items.sort();
                    }

                    var field = structuredClone(a);

                    i.revision.RevisionAdditionalFields.push(field);
                  });
                });
              },
              function () {}
            );
          }
        } else {
          if (itens.length > 0) {
            var first = itens[0];

            if (
              itens.every(function (i) {
                return (
                  i.revision.IdDocumentType === first.revision.IdDocumentType
                );
              })
            ) {
              return first.revision.documentType();
            }
          }
          return null;
        }
      }

      function workflow(value) {
        var itens = $scope.selectedItems();
        if (arguments.length > 0) {
          itens.forEach(function (i) {
            i.revision.workflow(value);
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];

            if (
              itens.every(function (i) {
                return i.revision.IdWorkflow === first.revision.IdWorkflow;
              })
            ) {
              return first.revision.workflow();
            }
          }
          return null;
        }
      }

      function selectionChanged(idx) {
        $scope.workflowSelected = idx;
        $scope.selectedItemsWorkflow(idx);
      }

      function selectedItemsWorkflow(ws) {
        var selected = $scope.uploader.queue
          .filter($scope.fileFilter)
          .filter(function (c) {
            if (
              $scope.workflowSelected &&
              c.selected &&
              c.revision._documentType !== null
            ) {
              c.revision._workflow = ws;
              c.revision.IdWorkflow = ws.Id;
            }
            return c.selected === true;
          });
        return selected;
      }

      function workflows() {
        if (
          $scope.folder() === null ||
          $scope.documentType() === null ||
          !PermPermissionStore.hasPermissionDefinition('WORKFLOW')
        ) {
          return null;
        }

        var folder = $scope.folder();
        var documentType = $scope.documentType();

        var cache = $scope.flowsCache.filter(function (c) {
          return (
            c.IdFolder === folder.Id && c.IdDocumentType === documentType.Id
          );
        });

        if (cache.length > 0) {
          return cache[0].flows;
        }

        var flow = {
          IdFolder: folder.Id,
          IdDocumentType: documentType.Id,
          flows: null,
        };

        $scope.flowsCache.push(flow);

        if ($scope.revisionCheckin) {
          flowService
            .listRevisionWorkflows($scope.revisionCheckin.id, 'checkin')
            .then((data) => {
              flow.flows = data.length > 0 ? data : null;

              if (data.length === 1) {
                $scope.workflow(data[0]);
              }
            });
        } else {
          flowService.listWorkflows(folder.Id, documentType.Id).then((data) => {
            flow.flows = data.length > 0 ? data : null;
            if (data.length === 1) {
              $scope.workflow(data[0]);
            }
          });
        }
      }

      function nextRevisionDate(value) {
        var itens = $scope.selectedItems();
        var documentType = $scope.documentType();

        if (arguments.length > 0) {
          itens.forEach(function (i) {
            i.revision.NextRevisionDate = value;
          });
        } else {
          if (itens.length > 0) {
            if (
              documentType.CanOverrideRevInterval === undefined ||
              documentType.CanOverrideRevInterval !== true
            ) {
              var interval =
                documentType.RevisionInterval === null
                  ? 0
                  : documentType.RevisionInterval;
              var date = new Date(Date.now() + interval * 24 * 60 * 60 * 1000);

              date.setHours(0);
              date.setMinutes(0);
              date.setSeconds(0);
              date.setMilliseconds(0);

              return date.valueOf();
            }

            var first = itens[0];
            var nextDate = first.revision.NextRevisionDate;
            var areEqual = itens.every(function (i) {
              return i.revision.NextRevisionDate === nextDate;
            });

            if (areEqual && nextDate !== undefined && nextDate !== null) {
              return nextDate;
            } else if (
              areEqual &&
              (nextDate === undefined || nextDate !== null)
            ) {
              var docInterval =
                documentType.RevisionInterval === null
                  ? 0
                  : documentType.RevisionInterval;
              nextDate = new Date(
                Date.now() + docInterval * 24 * 60 * 60 * 1000
              );

              nextDate.setHours(0);
              nextDate.setMinutes(0);
              nextDate.setSeconds(0);
              nextDate.setMilliseconds(0);

              return nextDate.valueOf();
            }
          }
          return null;
        }
      }

      function documentDate(value) {
        var itens = $scope.selectedItems();

        if (arguments.length > 0) {
          itens.forEach(function (i) {
            i.revision.DocumentDate = value;
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];
            return first.revision.DocumentDate;
          }
          return '';
        }
      }

      function notificationDays(value) {
        var itens = $scope.selectedItems();
        var documentType = $scope.documentType();
        if (arguments.length > 0) {
          itens.forEach(function (i) {
            i.revision.NotificationDays = value;
          });
        } else {
          if (itens.length > 0) {
            if (
              documentType.CanOverrideRevInterval === undefined ||
              documentType.CanOverrideRevInterval !== true
            ) {
              return documentType.NotificationDays;
            }

            var first = itens[0];
            var days = first.revision.NotificationDays;
            var areEqual = itens.every(function (i) {
              return i.revision.NotificationDays === days;
            });

            if (areEqual && days !== undefined && days !== null) {
              return days;
            } else if (areEqual && (days === undefined || days !== null)) {
              return documentType.NotificationDays;
            }
          }
          return null;
        }
      }

      function additionalField(value) {
        var itens = $scope.selectedItems();
        var id = this.field.id; // parseInt(field);
        var type = this.field.fieldType;

        if (arguments.length > 0) {
          //Verifica se o tipo é Boolean
          if (type === 1 && value === undefined) {
            value = false;
          }

          if (this.type === 2 && value === undefined) {
            value = false;
          }
          itens.forEach(function (i) {
            var fields = i.revision.RevisionAdditionalFields.filter(
              function (f) {
                return f.id === id;
              }
            );

            fields.forEach(function (f) {
              f.value = value;
            });
          });
        } else {
          if (itens.length > 0) {
            var first = itens[0];
            var firstField = first.revision.RevisionAdditionalFields.filter(
              (f) => f.id === id
            )[0];

            var areEqual = itens.every((i) => {
              var selectedField = i.revision.RevisionAdditionalFields.filter(
                (f) => f.id === id
              )[0];

              if (selectedField === undefined) {
                return false;
              }

              return selectedField.value === firstField.value;
            });

            if (areEqual) {
              if (
                type === 1 &&
                (firstField.value === undefined || firstField.value === null)
              ) {
                return false;
              }

              return firstField.value;
            }
          }

          return null;
        }
      }

      function additionalFields() {
        var itens = $scope.selectedItems();
        if (itens.length > 0) {
          var first = itens[0];

          if (
            itens.every(function (i) {
              return (
                i.revision.IdDocumentType === first.revision.IdDocumentType
              );
            })
          ) {
            return first.revision.RevisionAdditionalFields;
          }
        }
        return [];
      }

      function canSaveFields() {
        var canSave =
          $scope.uploader.queue.filter($scope.fileFilter).filter(function (i) {
            return i.revision.canSave() === false;
          }).length === 0;

        var notificationDays = $scope.validNotificationDays();

        var workflow =
          $scope.isWorkflowOptional ||
          $scope.workflows() === null ||
          ($scope.workflows() !== null &&
            $scope.workflows().length > 0 &&
            $scope.workflow() !== null);

        return canSave && notificationDays && workflow;
      }

      function canSaveAddFields() {
        var canSave =
          $scope.uploader.queue.filter($scope.fileFilter).filter(function (i) {
            return i.revision.canSaveAddFields() === false;
          }).length === 0;
        return canSave;
      }

      function isValid(value) {
        // CPF
        if (this.field.validationType === 1) {
          return validationService.validateCPF(value);
        }

        // CNPJ
        if (this.field.validationType === 2) {
          return validationService.validateCNPJ(value);
        }

        return true;
      }

      function validNotificationDays() {
        var itens = $scope.selectedItems();

        for (var i = 0, len = itens.length; i < len; i++) {
          var item = itens[i];
          var rev = item.revision;
          var doc = rev.documentType();

          // Verifica se pode definir o intervalo da revisao
          var canEditInterval =
            doc !== undefined &&
            doc !== null &&
            doc.RevisionInterval !== undefined &&
            doc.RevisionInterval !== null &&
            doc.CanOverrideRevInterval === true;

          // Verifica se pode alterar o intervalo
          if (!canEditInterval) {
            continue;
          }

          if (
            rev.NotificationDays === undefined ||
            rev.NotificationDays === null
          ) {
            continue;
          }

          if (rev.NotificationDays <= 0) {
            return false;
          }

          var days = rev.NotificationDays;
          var next = rev.NextRevisionDate;
          var today = new Date(Date.now());

          // A data da proxima revisão não foi alterada, calcular a data padrao
          if (next === undefined || next === null) {
            var interval = doc.RevisionInterval;

            var date = new Date(Date.now() + interval * 24 * 60 * 60 * 1000);
            today = new Date(Date.now());

            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);

            next = date;
          }

          today.setHours(0);
          today.setMinutes(0);
          today.setSeconds(0);
          today.setMilliseconds(0);

          // Verifica quantos dias há entre a data da proxima revisão e hoje
          var diff = (next.getTime() - today.getTime()) / 1000 / 60 / 60 / 24;

          // Verifica se o intervalo definido é maior que a os dias para a proxima revisao
          if (days >= diff) {
            return false;
          }
        }

        return true;
      }

      function canSave() {
        return $scope.canSaveFields() && $scope.canSaveAddFields();
      }

      function remove(item) {
        $scope.uploader.removeFromQueue(item);
      }

      function newFile(item) {
        item.revision = new uploadRevision(item);

        if ($scope.uploader.queue.filter($scope.fileFilter).length === 1) {
          item.selected = true;
        }

        var f = $scope.folder();
        if (f !== null) {
          item.revision.folder(f);
        } else {
          if ($rootScope.selectedTreeItem) {
            var canSend = false;
            if (authService.isAdmin()) {
              canSend = true;
            } else {
              if ($rootScope.selectedTreeItem.Features.length > 0) {
                var features = $rootScope.selectedTreeItem.Features;
                features.forEach(function (ft) {
                  if (ft === '11') {
                    canSend = true;
                  }
                });
              }
            }
            if (canSend) {
              var sendFolder = {};
              sendFolder.Id = $rootScope.selectedTreeItem.Id;
              sendFolder.name = $rootScope.selectedTreeItem.Name;
              sendFolder.TreeItemType =
                $rootScope.selectedTreeItem.TreeItemType;
              sendFolder.toString = function () {
                return this.name;
              };
              item.revision.folder(sendFolder);
            }
          }
        }
      }

      function executeOnSelected(action) {
        var selected = $scope.selectedItems();

        selected.forEach(function (c) {
          action(c);
        });
      }

      function allSelected(value) {
        if (value !== undefined) {
          var arrayIdWorkflow = [];
          var uploader = $scope.uploader.queue
            .filter($scope.fileFilter)
            .forEach(function (c) {
              arrayIdWorkflow.push(c.revision.IdWorkflow);
              c.selected = value;
            });

          if (
            arrayIdWorkflow.length > 1 &&
            !containsUndefinedOrNull(arrayIdWorkflow)
          ) {
            $scope.allSelectedWorkflow = checkShort(arrayIdWorkflow);
          }

          return uploader;
        } else {
          if ($scope.uploader.queue.filter($scope.fileFilter).length === 0) {
            return false;
          }

          var allSelected = $scope.uploader.queue
            .filter($scope.fileFilter)
            .every(function (c) {
              return c.selected === true;
            });

          return allSelected;
        }
      }

      function configurePreview(e) {
        if (!e.previewUrl) e.previewUrl = URL.createObjectURL(e._file);

        return e.previewUrl;
      }

      function toggleSelectAll() {
        var select = !$scope.allSelected();

        $scope.uploader.queue.filter($scope.fileFilter).forEach(function (c) {
          c.selected = select;
        });
      }

      function checkCollapseAllViewers() {
        let docsInPreview = $scope.uploader.queue
          .filter($scope.fileFilter)
          .find((obj) => {
            if (obj.peview === true) {
              return true;
            }

            return false;
          });

        if (docsInPreview !== undefined) {
          $scope.viewPreview = true;
        } else {
          $scope.viewPreview = false;
        }
      }

      function collapseAllViewers() {
        $scope.uploader.queue.filter($scope.fileFilter).forEach(function (c) {
          c.peview = false;
        });

        $scope.viewPreview = false;
      }

      function abbreviateTitle(title) {
        if (title !== undefined) {
          return `${title.substr(0, 15)}...`;
        }

        return '';
      }

      function canSelectFolder(item) {
        if (item.TreeItemType === ETreeItemTypes.FOLDER && item.HasPermission === ETreeItemTypes.FOLDER) {
          $scope.selectedFolder = item;
          return true;
        }
        return false;
      }

      function anySelected() {
        return $scope.selectedItems().length > 0;
      }

      function switchViewCallback() {}

      function pickFolder() {
        var modal = uibModal.open({
          animation: true,
          templateUrl: '/views/partials/pickFolder.html',
          controller: 'pickFolderController',
          backdrop: 'static',
          keyboard: true,
          size: 'sm',
          resolve: {
            treeSendFiles: function () {
              return true;
            },
            canSelectRepository: function () {
              return false;
            },
            idFolderNotShow: function () {
              return undefined;
            },
          },
        });

        modal.result.then(
          function (folder) {
            $scope.folder(folder);
          },
          function () {}
        );
      }

      function loadFolders() {
        treeService.getCanSendFolders().then(
          function (data) {
            $scope.folders = data;
          },
          function () {}
        );
      }

      function hasFreeGbs() {
        var comp = authService.getLoggedCompany();
        if (!comp.Company.Contract.GbsLimit) {
          return true;
        }
        if (comp.Company.Contract.SummedSizeInGbs) {
          var hasSpace =
            comp.Company.Contract.GbsLimit >
            comp.Company.Contract.SummedSizeInGbs;
          return hasSpace;
        }
        return true;
      }

      function initialize() {
        var first = $scope.uploader.queue.filter($scope.fileFilter)[0];

        first.selected = true;

        if (
          first.revision.IdFolder !== undefined &&
          first.revision.IdFolder !== null
        ) {
          $scope.selectedFolder = $scope.folder();
          $scope.loadDocumentTypes();
        }

        var config = systemConfigService.getConfig();
        if (config) {
          $scope.isWorkflowOptional = config.isWorkflowOptional;
          $scope.isDescriptionRevisionRequired =
            config.isDescriptionRevisionRequired;
        } else {
          systemConfigService.load().then(function (conf) {
            $scope.isWorkflowOptional = conf.isWorkflowOptional;
            $scope.isDescriptionRevisionRequired =
              conf.isDescriptionRevisionRequired;
          });
        }
      }

      function run() {
        try {
          $scope.revisionCheckin = revisionCheckin;

          $scope.uploader = uploader;
          $scope.flowsCache = [];
          $scope.workflowModule = flowService.workflowsEnabled;
          $scope.modalTitle = '';
          $scope.isWorkflowOptional = true;
          $scope.isDescriptionRevisionRequired = false;
          $scope.workflowSelected = '';
          $scope.viewPreview = false;
          $scope.folders = [
            {
              name: 'Loading',
            },
          ];
          $scope.allSelectedWorkflow = true;

          $scope.documentTypes = null;
          $scope.selectedFolder = null;

          $scope.loadDocumentTypes = logWrapper(
            loadDocumentTypes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.fileFilter = logWrapper(
            fileFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.totalFiles = logWrapper(
            totalFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedItems = logWrapper(
            selectedItems,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selecteds = logWrapper(
            selecteds,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.descriptionRequired = logWrapper(
            descriptionRequired,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.title = logWrapper(
            title,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signDocument = logWrapper(
            signDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCheckD4SignSign = logWrapper(
            canCheckD4SignSign,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signDocumentD4s = logWrapper(
            signDocumentD4s,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.description = logWrapper(
            description,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.keywords = logWrapper(
            keywords,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.folder = logWrapper(
            folder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.documentType = logWrapper(
            documentType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.workflow = logWrapper(
            workflow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectionChanged = logWrapper(
            selectionChanged,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedItemsWorkflow = logWrapper(
            selectedItemsWorkflow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.workflows = logWrapper(
            workflows,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.nextRevisionDate = logWrapper(
            nextRevisionDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.documentDate = logWrapper(
            documentDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.notificationDays = logWrapper(
            notificationDays,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.additionalField = logWrapper(
            additionalField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.additionalFields = logWrapper(
            additionalFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSaveFields = logWrapper(
            canSaveFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSaveAddFields = logWrapper(
            canSaveAddFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isValid = logWrapper(
            isValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validNotificationDays = logWrapper(
            validNotificationDays,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSave = logWrapper(
            canSave,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.remove = logWrapper(
            remove,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.newFile = logWrapper(
            newFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.executeOnSelected = logWrapper(
            executeOnSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.allSelected = logWrapper(
            allSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.configurePreview = logWrapper(
            configurePreview,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleSelectAll = logWrapper(
            toggleSelectAll,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.checkCollapseAllViewers = logWrapper(
            checkCollapseAllViewers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.collapseAllViewers = logWrapper(
            collapseAllViewers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.abbreviateTitle = logWrapper(
            abbreviateTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSelectFolder = logWrapper(
            canSelectFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.anySelected = logWrapper(
            anySelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.switchViewCallback = logWrapper(
            switchViewCallback,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.pickFolder = logWrapper(
            pickFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadFolders = logWrapper(
            loadFolders,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasFreeGbs = logWrapper(
            hasFreeGbs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initialize = logWrapper(
            initialize,
            runtimeConstant.isDebugControllersInternals
          );

          if ($scope.revisionCheckin) {
            $scope.additionalFields();
            $scope.modalTitle = $filter('translate')('CHECKIN');
          } else {
            $scope.modalTitle = $filter('translate')('SEND FILES');
            $scope.uploader.onAfterAddingFile = $scope.newFile;
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
